import React from 'react'
import './pageTitle.scss';
import {useTranslation} from 'react-i18next';

type PageTitleType = {
    title: string,
    description?: string,
}
const PageTitle  = ({title, description}: PageTitleType) => {
    const {t} = useTranslation();
    return (
        <>
        <div className='motif-body1-default-regular page-title'>{t(title)}</div>
        {description && <div className='motif-body2-default-regular page-description'>{t(description)}</div>}
        </>
    )
}

export default PageTitle;